<template>
  <router-link
    :to="{
      path: toPath(false),
      state: { data: JSON.stringify('openNotice') },
    }"
  >
    <div class="bg-[#B2A0FF] h-[80px] flex justify-center cursor-pointer">
      <img
        src="@/assets/image/banner/top_banner_number.png"
        class="min-w-[1440px] h-[80px] mobile:hidden"
        id="Click_등기수거poc_web"
      />
      <img
        src="@/assets/image/banner/top_banner_number_mobile.png"
        class="min-w-[390px] h-[80px] desktop:hidden"
        id="Click_등기수거poc_mobile"
      />
    </div>
  </router-link>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

/**
 * A. 띠배너클릭시 사이트메뉴 화면이동 케이스
 * @param byAuth 권한분별필요한메뉴인지여부(boolean)
 * */
const toPath = (byAuth: boolean) => {
  if (byAuth) {
    // A-1. 회원(로그인) 권한 판별
    const store = useStore();
    const isAuthenticated = computed(() => store.getters['auth/getSessionToken']());
    return isAuthenticated.value ? '/outbound/quick' : '/signin';
  } else {
    // A-2. 권한 상관없는 프로모션 안내
    return '/help/notice';
  }
};

/** B. 띠배너클릭시 새창 URL 이동 케이스 */
const openUrl = () => {
  const vocUrl = 'https://forms.gle/zpAXnzxKTL4dAgsJ7';
  window.open(vocUrl, '_blank');
};
</script>
